export const STALE_MODULE_RELOAD_KEY = 'ruzuku:staleModuleReloadAttempt';

export const PENDING_CHUNK_RELOAD_KEY = 'ruzuku:pendingChunkReload';

export type PendingChunkReload = {
  context: string;
  at: number;
  url: string;
  message?: string;
};
